

























import Vue from "vue";
import { Component, Watch, Prop } from "vue-property-decorator";
import WorkflowButtons from '../ProgressBar/WorkflowButtons.vue';

@Component({
    components: {
        WorkflowButtons
    }
})
export default class NavigationButtonComponent extends Vue {
    @Prop() schema!: any;
    @Prop() workFlowItems: any;
    @Prop() entity: any;
    @Prop() preValidation: any;
    @Prop() selectedKey!: string;
    @Prop() selectedSubKey!: string;
    @Prop() isdirty!: boolean;
    @Prop() enableCycle: boolean;
    @Prop() submitAtEnd: boolean;
    @Prop() actionPermission: any;

    /** get all subtabs */
    get subSchema(): any {
        if (this.schema && this.schema.properties) {
        return this.schema.properties[this.selectedKey];
        } else {
        return {};
        }
    }

    /** get left navigation menu */
    get subProps(): any {
        if(this.subSchema && this.subSchema.properties) {
            return Object.keys(this.subSchema.properties);
        } else {
            return [];
        }
    }

    /** get top menus */
    get menuProps(): any {
        if (this.schema && this.schema.properties) {
            return Object.keys(this.schema.properties);
        } else {
            return [];
        }
    }

    /** Get first node from the schema */
    get firstProp(): any {
        let topMenu = '';
        let subMenu = '';

        if(this.schema && this.schema.properties) {
            if(this.selectedKey) {
                topMenu = Object.keys(this.schema.properties)[0];
                if(this.selectedSubKey) {
                    const subProps = this.schema.properties[topMenu];
                    if(subProps && subProps.properties) {
                        subMenu = Object.keys(subProps.properties)[0];
                    }
                }
            }
        }

        return { topMenu, subMenu };
    }

    /** Get last node from the schema */
    get lastProp(): any {
        let topMenu = '';
        let subMenu = '';

        if(this.schema && this.schema.properties) {
            if(this.selectedKey) {
                const topMenus = Object.keys(this.schema.properties);
                topMenu = topMenus[topMenus.length - 1];
                if(this.selectedSubKey) {
                    const subProps = this.schema.properties[topMenu];
                    if(subProps && subProps.properties) {
                        const subMenus = Object.keys(subProps.properties);
                        subMenu = subMenus[subMenus.length - 1];
                    }
                }
            }
        }

        return { topMenu, subMenu };
    }

    /** move to next tab */
    next() {
        if(this.selectedSubKey && this.subProps.indexOf(this.selectedSubKey) < (this.subProps.length - 1) ) {
            this.$emit('submenuChanged', {}, this.subProps[this.subProps.indexOf(this.selectedSubKey) + 1]);
        }            
        else {
            this.$emit('topmenuChanged', this.menuProps[this.menuProps.indexOf(this.selectedKey) + 1] );
        }            
    }

    reset() {
        if(this.selectedSubKey && this.subProps.indexOf(this.selectedSubKey) === (this.subProps.length - 1) ) {
            this.$emit('submenuChanged', {}, this.subProps[0]);
        }            
        else {
            this.$emit('topmenuChanged', this.menuProps[0] );
        } 
    }

    /** move to previous tab */
    previous() {
        if(this.selectedSubKey && this.subProps.indexOf(this.selectedSubKey) > 0 ) {
            this.$emit('submenuChanged', {}, this.subProps[this.subProps.indexOf(this.selectedSubKey) - 1]);
        }            
        else {
            this.$emit('topmenuChanged', this.menuProps[this.menuProps.indexOf(this.selectedKey) - 1] );
        }
    }
    
}
